import { render, staticRenderFns } from "./PatientSurgeryStaff.vue?vue&type=template&id=28c5d140&scoped=true"
import script from "./PatientSurgeryStaff.vue?vue&type=script&lang=js"
export * from "./PatientSurgeryStaff.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgeryStaff.vue?vue&type=style&index=0&id=28c5d140&prod&scoped=true&lang=scss"
import style1 from "./PatientSurgeryStaff.vue?vue&type=style&index=1&id=28c5d140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5d140",
  null
  
)

export default component.exports